import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
//npm run build ked ides do di      
// Načítanie JSON konfiguračného súboru pomocou fetch
  
import {exportAndShareCSV,searchButton, deleteItems, calc, calcKS, storeButtonHandler,loadStoredItems,getId,DisplayTable,spocitadloTotal } from './utils';
import { extractAndSetDimensions } from './calculatore';
// Vytvor absolútnu cestu k JSON súboru
//import config from '../static/config.json';

// Použitie konfiguračných hodnôt
//console.log(config.websheetUrl);
let websheetUrl;
let sheetName;
let allowedOrderNumbers = [];  // Premenná na uloženie povolených čísiel objednávok
let dataLoaded = false; // Premenná na sledovanie načítania údajov


// Funkcia na získanie parametra z URL
function getSheetNameFromURL() {    
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('sheet'); // Získa parameter sheetName z URL
}

// Funkcia na načítanie údajov z localStorage alebo config.json
function initializeData() {
    const storedUrl = localStorage.getItem('websheetUrl');
    const storedsheetName = localStorage.getItem('sheetName');

    // Skontroluj, či sheetName existuje v URL
    const urlSheetName = getSheetNameFromURL();
    if (urlSheetName) {
        sheetName = urlSheetName;  // Použije sheetName z URL
        localStorage.setItem('sheetName', sheetName);  // Ulož ho do localStorage
        document.getElementById('websheetsheetname').value = sheetName; // Predvyplní názov hárku do inputu
    } else if (storedsheetName) {
        sheetName = storedsheetName;  // Použije sheetName z localStorage
        document.getElementById('websheetsheetname').value = sheetName; // Predvyplní názov hárku
    }

    // Nastav URL, ak existuje v localStorage
    if (storedUrl) {
        document.getElementById('websheetUrlInput').value = storedUrl; // Predvyplní URL do inputu
        websheetUrl = storedUrl;
    }

    // Ak nie sú údaje v localStorage ani v URL, načítame ich z config.json
    if (!storedUrl || (!storedsheetName && !urlSheetName)) {
        loadDefaultConfig();
    } else {
        // Ak sú údaje už v localStorage alebo URL, načítaj údaje zo sheets, ak ešte neboli načítané
        if (!dataLoaded) {
            loadDataFromWebsheet();
            dataLoaded = true; // Nastav premennú na true
        }
    }

    // Zabezpeči, aby si mal povolené čísla objednávok po načítaní
    if (!allowedOrderNumbers.length) {
        loadDefaultConfig(); // Znova načítaj default konfig
    }
}




function loadDefaultConfig() {
    fetch('config.json')
        .then(response => {
            if (!response.ok) {
                throw new Error('Chyba siete pri načítaní config.json');
            }
            return response.json();
    })
    .then(config => {
        
        // Ak localStorage neobsahuje URL, načítame ju z config.json a uložíme do localStorage
        if (!localStorage.getItem('websheetUrl') && config.websheetUrls && config.websheetUrls.length > 0) {
            websheetUrl = config.websheetUrls[0];  // Načíta URL z config.json
            localStorage.setItem('websheetUrl', websheetUrl); // Uloží URL do localStorage
            document.getElementById('websheetUrlInput').value = websheetUrl; // Aktualizuje input
        }

        // Ak localStorage neobsahuje názov hárku, načítame ho z config.json a uložíme do localStorage
        if (!localStorage.getItem('sheetName') && config.sheetname && config.sheetname.length > 0) {
            sheetName = config.sheetname[0];  // Načíta názov hárku z config.json
            localStorage.setItem('sheetName', sheetName); // Uloží názov hárku do localStorage
            document.getElementById('websheetsheetname').value = sheetName; // Aktualizuje input
        }

        // Načítanie orderNumbers z config.json
        if (config.orderNumbers && config.orderNumbers.length > 0) {
            allowedOrderNumbers = config.orderNumbers.map(String); // Uistite sa, že všetky orderNumbers sú reťazce
           
        } // Načítanie údajov z Websheet, ak ešte neboli načítané
        if (!dataLoaded) {
            loadDataFromWebsheet();
            dataLoaded = true; // Nastav premennú na true
        }
    })
    .catch(error => {
        console.error('Chyba pri načítaní config.json:', error);
        alert('Chyba pri načítaní konfiguračného súboru.');
    });  
} 

    document.addEventListener('DOMContentLoaded', function() {  

// Get the button and the calculator div
const calculatorButton = document.getElementById('calculatorID');
const calculatorDiv = document.querySelector('.calculator');

// Add click event listener to the button
calculatorButton.addEventListener('click', () => {
    // Toggle the display property of the calculator div
    if (calculatorDiv.style.display === 'none' || calculatorDiv.style.display === '') {
        calculatorDiv.style.display = 'flex'; // Show the calculator
    } else {
        calculatorDiv.style.display = 'none'; // Hide the calculator
    }
});

        document.getElementById('btnShareCSV').addEventListener('click', exportAndShareCSV);

    initializeData()  

    document.getElementById("hideDPH").addEventListener("click", function() {
        document.querySelectorAll(".DPHcka").forEach(dph => {
            dph.classList.toggle("hiddenCat");
        });
    });

    document.getElementById("modalCloseButt").addEventListener("click", function() {
        document.getElementById("ContainerProduktovy").style.display = "block";
    });

    // Event listener pre tlačidlo na načítanie čísla objednávky
    document.getElementById('loadorderNumber').addEventListener('click', function() {
        const enteredOrderNumber = document.getElementById('orderNumber').value.trim();
       

        // Konvertujte zadané číslo objednávky na reťazec pre porovnanie
        const enteredOrderNumberAsString = String(enteredOrderNumber);
       

       // Overenie, či zadané číslo objednávky existuje v zozname povolených orderNumbers
if (allowedOrderNumbers.includes(enteredOrderNumberAsString)) {
    localStorage.setItem("orderNumber", enteredOrderNumberAsString); // Uložíme číslo objednávky do localStorage
    document.getElementById("errorMessageOrder").innerText = "Číslo objednávky bolo overené a uložené.";
    document.getElementById("errorMessageOrder").style.display = "block"; // Zobrazíme div

    // Skrytie správy po 3 sekundách
    setTimeout(() => {
        document.getElementById("errorMessageOrder").style.display = "none";
    }, 3000); // 3000 ms = 3 sekundy
} else {
    document.getElementById("errorMessageOrder").innerText = "Neplatné číslo objednávky. Skúste znova.";
    document.getElementById("errorMessageOrder").style.display = "block"; // Zobrazíme div

    // Skrytie správy po 3 sekundách
    setTimeout(() => {
        document.getElementById("errorMessageOrder").style.display = "none";
    }, 3000); // 3000 ms = 3 sekundy
}

    });   

    // Event listener pre tlačidlo na vymazanie čísla objednávky z localStorage
    document.getElementById('clearorderNumber').addEventListener('click', function() {
        localStorage.removeItem("orderNumber");
        document.getElementById('orderNumber').value = '';    
    });

    // Ak je číslo objednávky už v localStorage, predvyplň input
    const storedOrderNumber = localStorage.getItem("orderNumber");
    if (storedOrderNumber) {
        document.getElementById('orderNumber').value = storedOrderNumber;
    }
});

// Funkcia na validáciu a načítanie údajov
function validateAndLoadData(inputUrl) {
    // Validácia URL pomocou regexu
    const isValidUrl = validateGoogleSheetUrl(inputUrl);

    if (isValidUrl) {
        // Pokúsime sa načítať údaje z Google Sheet
        fetchGoogleSheet(inputUrl)
            .then(response => {
                if (response.ok) {
                    // Ak fetch bol úspešný, uložíme URL a načítame údaje
                    websheetUrl = inputUrl;
                    localStorage.setItem('websheetUrl', websheetUrl); // Uloží URL do localStorage
                    loadDataFromWebsheet(); // Načíta údaje
                } else {
                    showError("Nemôžem načítať údaje z tohto URL. Skontrolujte hárok.");
                }
            })
            .catch(error => {
                console.error("Chyba pri načítaní hárku:", error);
                showError("Nemôžem načítať údaje z tohto URL. Skontrolujte hárok.");
            });
    } else {
        showError("Zadaný URL link je neplatný.");
    }
}

// Funkcia na validáciu Google Sheets URL
function validateGoogleSheetUrl(url) {
    // Jednoduchý regex na validáciu Google Sheets URL
    const regex = /https:\/\/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/;
    return regex.test(url);
}

// Funkcia na overenie, či je Google Sheet URL platná
function fetchGoogleSheet(url) {
    // Skonvertujeme URL na formát CSV exportu (alebo JSON)
    const sheetId = url.match(/spreadsheets\/d\/([a-zA-Z0-9-_]+)/)[1];
    const sheetUrl = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:csv`;

    // Použijeme fetch na načítanie Google Sheet údajov
    return fetch(sheetUrl);
}


// Pripojenie event listeneru k tlačidlu na načítanie websheetu
document.getElementById('loadWebsheetButton').addEventListener('click', function() {
    const urlInput = document.getElementById('websheetUrlInput').value.trim();
    
    // Volanie funkcie na validáciu a načítanie údajov
    validateAndLoadData(urlInput);
});


// Po kliknutí na tlačidlo "Vymazať URL"
document.getElementById('clearWebsheetButton').addEventListener('click', function() {
    localStorage.removeItem('websheetUrl'); // Vymaž URL z localStorage
    document.getElementById('websheetUrlInput').value = ''; // Vyprázdni vstup
    loadDataFromWebsheet()
});




document.getElementById('loadWebsheetButtonsheetname').addEventListener('click', function() {
    const inputUrl = document.getElementById('websheetUrlInput').value;
    const userSheetName = document.getElementById('websheetsheetname').value;
    
    if (userSheetName) {
      //  console.log('vzdy')
        sheetName = userSheetName;  // Aktualizuj názov hárku podľa vstupu
        localStorage.setItem('sheetName', sheetName);  // Ulož názov hárku do localStorage
        loadDataFromWebsheet();  // Načíta údaje po aktualizácii názvu hárku

    } else {
        alert('Prosím, vložte platný názov hárku.');
    }
});  

// Funkcia na zobrazenie chybovej správy
function showError(message) {
    const errorMessageDiv = document.getElementById('errorMessageURL');
    errorMessageDiv.textContent = message; // Nastavenie textu správy
    errorMessageDiv.style.display = 'block'; // Zobrazenie správy
    
    // Skryť chybovú správu po 5 sekundách
    setTimeout(() => {
        hideError();
    }, 2000); // 5000 ms = 5 sekúnd
}

// Funkcia na skrytie chybovej správy
function hideError() {
    const errorMessageDiv = document.getElementById('errorMessageURL');
    errorMessageDiv.textContent = ''; // Vymazanie textu správy
    errorMessageDiv.style.display = 'none'; // Skrytie správy
}

// Funkcionalita pre vymazanie názvu hárku
document.getElementById('clearWebsheetButtonsheetname').addEventListener('click', function() {
    localStorage.removeItem('sheetName');  // Vymaž názov hárku z localStorage
    document.getElementById('websheetsheetname').value = '';  // Vyprázdni vstup pre názov hárku
    loadDataFromWebsheet()
});

// Funkcia pre načítanie údajov z Google Sheet
function loadDataFromWebsheet() {
   
    // Voláme funkcie na načítanie údajov
    loadPricelist();
    loadDimensions();   
    loadSettings(); 
}   


// Skryť obsah na začiatku
document.body.style.visibility = 'hidden'; // Skryť celý obsah stránky

// Funkcia na zobrazenie obsahu po oneskorení
setTimeout(function() {
    // Urobiť obsah viditeľným
    document.body.style.visibility = 'visible';
    const firstButton = document.querySelector('.valueofinput');
    if (firstButton) {
        // Spustiť kliknutie na prvý element
        firstButton.click();
    }

}, 1500); // Oneskanie 1000 milisekúnd (1 sekunda)

// Počkajte na načítanie DOM a pridajte event listenery
document.addEventListener("DOMContentLoaded", function() {
 

    window.onload = function() {  
        DisplayTable();
        spocitadloTotal();  // Ak chceš hneď zobraziť aj celkovú cenu
    };
    
    // Pridajte event listener pre kliknutie na prvok s triedou 'svgsearch'
document.querySelector('.svgsearch').addEventListener('click', function() {

  //  document.getElementById("myInput").focus();
    // Získajte prvky 'myInput' a 'catDiv'
    var input = document.getElementById('myInput');
    var catDiv = document.getElementById('catDiv');

    // Pridá funkciu pre kliknutie na button
    input.addEventListener('click', function() {
        input.value = '';  // Vyčistí hodnotu inputu
  });


    // Toggle logika pre 'myInput'
    if (input.style.display === 'none' || input.style.display === '') {
        input.style.display = 'block'; // Zviditeľní sa input
    } else {
        input.style.display = 'none'; // Skryje sa input
    }

    // Toggle logika pre 'catDiv'
    if (catDiv.style.display === 'none' || catDiv.style.display === '') {
        catDiv.style.display = 'flex'; // Zviditeľní sa div s display flex
    } else {
        catDiv.style.display = 'none'; // Skryje sa div
    }
});

    
 // Nastavenie event listenerov pre tlačidlá
document.querySelector('.svgsearch').addEventListener('click', searchButton);
document.querySelector('#deleteButton').addEventListener('click', deleteItems);

 


document.querySelector('#store').addEventListener('click', storeButtonHandler);

// Event listener pre kalkulácie
document.getElementById('amount').addEventListener('input', calc);
document.getElementById('quantity').addEventListener('input', calc);
document.getElementById('quantityKS').addEventListener('input', calcKS);

// Načítanie uložených údajov z localStorage pri načítaní stránky
window.addEventListener('load', loadStoredItems);
   


    document.getElementById("customDim").addEventListener("click", () => {
        const widthElement = document.getElementById("width1");
        const heightElement = document.getElementById("height1");
        
        // Toggle class to switch between hidden and flex
        widthElement.classList.toggle("d-flex");
        heightElement.classList.toggle("d-flex");
    });
});

function addItemToStore(item) {
    let entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    entries.push(item);
    localStorage.setItem("allEntries", JSON.stringify(entries));
    updateResultAllFromStore();  // Aktualizuj celkovú cenu po pridaní položky
}

function deleteItemFromStore(id) {
    let entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    entries = entries.filter(entry => entry.id !== id);
    localStorage.setItem("allEntries", JSON.stringify(entries));
    updateResultAllFromStore();  // Aktualizuj celkovú cenu po vymazaní položky
}

function updateResultAllFromStore() {
    let entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    let total = 0;

    entries.forEach(entry => {
        total += parseFloat(entry.total || 0);  // Používa hodnotu `total` z položky
    });

    updateResultAll(total);  // Zavolaj funkciu na aktualizáciu resultAll a následne prepočet zľavy a DPH
}




function getText(data) {
    // Vyčisti obsah catDiv pred pridaním nových kategórií
    let catDiv = document.getElementById("catDiv");
    catDiv.innerHTML = '<div class="catDivAll"><a id="showAll">ALL</a></div>';

    let addedCategories = new Set();  // Set na sledovanie pridaných kategórií

    // Vyčisti kontajner produktov
    let container = document.getElementById("ContainerProduktovy");
    container.innerHTML = '';

    data.forEach((row) => {
        let category = row.cat?.value ?? "Unknown";
        let title = row.tit?.value ?? "";
        let subtitle = row.sub?.value ?? "";
        let price = parseFloat(row.price?.value ?? 0);
        let unit = row.unit?.value ?? "";

        if (isNaN(price)) price = 0;

        let catClass = category.replace(/\s+/g, "-").toLowerCase();
        if (!category.trim()) {
            console.warn(`Skipping row with empty category: ${JSON.stringify(row)}`);
            return;
        }

        // Pridaj kategóriu do catDiv len ak ešte nebola pridaná
        if (!addedCategories.has(category)) {
            let l = document.createElement("a");
            l.setAttribute("href", "#");
            l.classList.add("catDivBla", catClass);
            l.innerHTML = category;
            catDiv.appendChild(l);
            addedCategories.add(category);  // Pridaj do Setu, aby sa kategória nepridávala viackrát
        }

        // Vytvorenie karty produktu
        let s = document.createElement("div");
        s.classList.add("card", "w-100", "my-1", catClass);
        s.innerHTML = `
            <div class="card-body row">
                <div class="hiddenCat">${category}</div>
                <div class="col-10">
                    <h5 class="card-title mb-1">${title}</h5>
                    <div style="display:flex;justify-content: space-between;">
                    <small class="card-subtitle">${subtitle}</small>
                    <small class="card-subtitle">${price}€/${unit}</small></div>
                </div>
                <div class="col-2 d-flex justify-content-center align-items-center">
                    <button value="${price}" card-title="${subtitle}" card-title2="${title}" unit="${unit}" type="button" class="btn btn-outline-danger btn-lg d-flex valueofinput">
                        <i style="" class="bi bi-plus"></i>
                    </button>
                </div>
            </div>
        `;
        container.appendChild(s);
    });

    // Filtrovanie kariet podľa kategórie
    document.querySelectorAll("#catDiv a").forEach(anchor => {
        anchor.addEventListener("click", function() {
            let t = this.textContent.toLowerCase();
            if (t === "all") {
                // Zobraziť všetky karty
                document.querySelectorAll(".card").forEach(card => {
                    card.style.display = "";
                });
                document.getElementById("myInput").value = "";
            } else {
                // Zobraziť len karty v zvolenej kategórii
                document.getElementById("myInput").value = t + " ";
                document.querySelectorAll(".card").forEach(card => {
                    card.style.display = card.textContent.toLowerCase().includes(t) ? "" : "none";
                });
            }
        });
    });

    // Filtrovanie podľa textu zadaného v myInput
    document.getElementById("myInput").addEventListener("input", function() {
        let filter = this.value.toLowerCase();
        
        // Zobrazovať karty, ktoré obsahujú text zadaný používateľom
        document.querySelectorAll(".card").forEach(card => {
            let cardText = card.textContent.toLowerCase();
            if (cardText.includes(filter)) {
                card.style.display = ""; // Zobraziť kartu, ak text sedí
            } else {
                card.style.display = "none"; // Skryť kartu, ak text nesedí
            }
        });
    });



    function generateId() {
        let entries = JSON.parse(localStorage.getItem("allEntries")) || [];
        return entries.length > 0 ? entries[entries.length - 1].id + 1 : 1;
    }

    function calculateAndStore() {



        // Získanie aktívneho tlačidla
        let activeButton = document.querySelector(".valueofinput.active");
    
        if (!activeButton) {
            console.log("Nie je zvolené žiadne tlačidlo.");
            return;
        }
    
        // Získanie hodnoty jednotky a ceny z tlačidla
        let unit = activeButton.getAttribute("unit");
        let t = parseFloat(activeButton.getAttribute("value"));
    
        // Získanie hodnôt z inputov
        let e = parseFloat(document.getElementById("quantityKS").value) || 0;
        let amountInput = document.getElementById("amount");
        let quantityInput = document.getElementById("quantity");
    
        let amount = parseFloat(amountInput.value);
        if (isNaN(amount)) {
            amount = 100;
            amountInput.value = 100;
        }
    
        let quantity = parseFloat(quantityInput.value);
        if (isNaN(quantity)) {
            quantity = 100;
            quantityInput.value = 100;
        }
    
        let i;
    
        // Ak je unit 'cm', vykoná sa prepočet
        if (unit === "m2") {
            i = (amount * quantity / 10000) * e * t;
        } 
        
        // Ak je unit 'mm', prepočet na cm
        else if (unit === "") {
            i = (amount * quantity / 10000) * e * t;  // mm sa prevedú na cm (mm = cm / 10)
        } 
        else {
            // Ak unit nie je 'cm', použije sa iba hodnota bez prepočtu
            i = t * e;
        }
    
        let total = Math.round(i * 100) / 100;
    
        // Nastavenie výslednej hodnoty do poľa 'total'
        document.getElementById("total").value = total.toString();
    }
    
    // Pridanie 'active' triedy a volanie calculateAndStore na kliknutie
    document.querySelectorAll('.valueofinput').forEach(button => {
        button.addEventListener('click', function() {

           

            // Odstránenie triedy 'active' z predchádzajúceho tlačidla, ak existuje
            document.querySelectorAll('.valueofinput').forEach(btn => btn.classList.remove('active'));
            
            // Pridanie triedy 'active' na aktuálne kliknuté tlačidlo
            this.classList.add('active');
    
            // Získanie hodnoty z aktuálne aktívneho tlačidla a prepočet
            let pricePerM2 = parseFloat(this.getAttribute('value'));
            let unit = this.getAttribute('unit');

            extractAndSetDimensions()
    
            // Nastavenie hodnoty do inputu 'total' a volanie calculateAndStore
            if (!isNaN(pricePerM2)) {
                calculateAndStore();
                
            } else {
                console.warn("Hodnota z tlačidla je neplatná.");
            }
        });
    });
    



    
}

function loadPricelist() {

  
// Načítať údaje z Google Sheets
websheet("pricelist", {
    caching: false,
    url: websheetUrl,
    sheet: sheetName,
    onLoaded: function(data) {
        if (!data || data.length === 0) {
            console.error("No data loaded from the websheet");
            return;
        }
        getText(data);
    },
    onError: function(error) {
        console.error("Error loading data from websheet:", error);
        alert("UPS..asi nemáš platnú adresu URL");
    }
});
}

function getTextDim(data) {
    data.forEach((row) => {

        // Uistite sa, že typ je reťazec a ak nie je prítomný, nastavte ho na "Unknown"
        let type = row.typ && row.typ.value !== null ? String(row.typ.value) : "Unknown";
        let width = parseFloat(row.wit?.value) || 100;
        let height = parseFloat(row.hei?.value) || 100;

        // Vytvorenie nových HTML prvkov
        let a = document.createElement("div");
        a.classList.add("form-group", "m-1");

        let l = document.createElement("button");
        l.setAttribute("id", `${type}${width}${height}`);
        l.classList.add("form-control", "valueofinputDimensions");
        l.setAttribute("type", "button");
        l.setAttribute("valueW", width);
        l.setAttribute("valueH", height);
        l.innerHTML = type;

        let n = document.getElementById("dimensions");
        a.appendChild(l);
        n.appendChild(a);

        // Pridanie udalosti kliknutia na tlačidlo
        l.addEventListener("click", function() {
            this.focus();
            document.querySelectorAll(".valueofinputDimensions.activeDim").forEach(activeButton => {
                activeButton.classList.remove("activeDim");
            });
            this.classList.add("activeDim");

            let t = parseFloat(this.getAttribute("valueW")) || 0;
            let e = parseFloat(this.getAttribute("valueH")) || 0;



            let iElement = document.querySelector(".valueofinput.active");
            
            if (!iElement) {
                alert("Prosím, najprv vyberte nejakú položku pluskom.");
                return;
            }
            
            let i = parseFloat(iElement.getAttribute("value")) || 0;
            let a = parseFloat(document.getElementById("quantityKS").value) || 0;

           

            if (isNaN(t) || isNaN(e) || isNaN(i) || isNaN(a)) {
                console.error("Jedna alebo viac hodnôt nie je platné číslo:", { t, e, i, a });
                return;
            }

            document.getElementById("amount").value = t;
            document.getElementById("quantity").value = e;

           
             let total = (t * e / 100 / 100) * a * i;

            if (!isNaN(total)) {
                document.getElementById("total").value = total.toFixed(2);
            } else {
                console.error("Výpočet vrátil NaN:", { total });
            }
        });
    });
    

    document.getElementById("btnPrint").addEventListener("click", function() {
        document.getElementById("ContainerProduktovy").style.display = "none";
        document.getElementById("modalCloseButt").style.display = "none";
        let modalCloseButton = document.getElementById("modalCloseButt");
         
    modalCloseButton.style.background = "transparent";
        // Skrytie všetkých tlačidiel s triedou 'delete'
    let deleteButtons = document.querySelectorAll(".delete");
    deleteButtons.forEach(button => {
        button.style.display = "none";
    });
        try {
            document.execCommand("print", false, null) || window.print(); 
        } catch {
            window.print();
        }
    });

    
    
}



function loadDimensions() {
  
// Načítať údaje z Google Sheets
websheet("pricelist", {
    caching: false,
    url: websheetUrl,
    sheet: "dimensions",
    onLoaded: function(data) {
        if (!data || data.length === 0) {
            console.error("No data loaded from the websheet");
            return;
        }

        const dimensionsData = data.slice(0);
      //  console.log(dimensionsData)
        getTextDim(dimensionsData);
    },
    onError: function(error) {
        console.error("Error loading data from websheet:", error);
        alert("UPS..asi nemáš platnú adresu URL");
    }
});
}

function loadSettings() {
// Načítať údaje z Google Sheets
document.body.classList.add('loading'); // Pridajte triedu 'loading' na začiatku


websheet("pricelist", {
    caching: false,
    url: websheetUrl,
    sheet: "settings",
    onLoaded: function(data) {
        if (!data || data.length === 0) {
            console.error("No data loaded from the websheet");
            return;
        }

        let hlavickaValue = data[0].hlavicka ? data[0].hlavicka.value : "title";
        let logoUrl = data[0].logoUrl ? data[0].logoUrl.value : "logo";
        let logo = data[0].logo ? data[0].logo.value : "logo";
        let dimValue = data[0].dim && data[0].dim.value ? data[0].dim.value.toString().toLowerCase() === "true" : false;
        let dimOpen = data[0].dimOpen && data[0].dimOpen.value ? data[0].dimOpen.value.toString().toLowerCase() === "false" : true;
        let hideURL = data[0].hideURL && data[0].hideURL.value ? data[0].hideURL.value.toString().toLowerCase() === "false" : true;
        let hideSheet = data[0].hideSheet && data[0].hideSheet.value ? data[0].hideSheet.value.toString().toLowerCase() === "false" : true;
        let hideOrder = data[0].hideOrder && data[0].hideOrder.value ? data[0].hideOrder.value.toString().toLowerCase() === "false" : true;
        let dark = data[0].dark && data[0].dark.value ? data[0].dark.value.toString().toLowerCase() === "true" : false;
        let hideCalculator = data[0].hideCalculator && data[0].hideCalculator.value ? data[0].hideCalculator.value.toString().toLowerCase() === "false" : true;
        let hideDPH = data[0].hideDPH && data[0].hideDPH.value ? data[0].hideDPH.value.toString().toLowerCase() === "false" : true;

    document.body.classList.toggle('dark', dark);

    
    // Vložiť tento kód do funkcie alebo priamo do onLoaded callbacku
setTimeout(function() {
    // Pridajte alebo odstráňte triedu dark na <nav>
    const navElement = document.querySelector('nav');
    if (navElement) {
        navElement.classList.toggle('dark', dark);
    }
    
    document.querySelectorAll('.card').forEach(cardElement => {
        cardElement.classList.toggle('dark', dark); // Pridá triedu 'dark' pre všetky karty
        // cardElement.style.border = "1px solid #5a5a5a"; // Okraj pre tmavý režim
    });

    const container = document.getElementById('containerForCount');
    if (container) {
        container.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
    }

    document.querySelectorAll('button').forEach(buttonElement => {
        buttonElement.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
    });

    document.querySelectorAll('input').forEach(inputElement => {
        inputElement.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
    });

    // Pridajte triedlu 'dark' do všetkých prvkov s triedou svginfo
    document.querySelectorAll('.svginfo').forEach(svginfoElement => {
        svginfoElement.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
    });

    const catDiv = document.getElementById('catDiv');
    if (catDiv) {
        catDiv.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
        // Pridajte triedlu 'dark' aj k všetkým podprvkom v catDiv
        catDiv.querySelectorAll('*').forEach(childElement => {
            childElement.classList.toggle('dark', dark); // Pridá triedu 'dark' aj podprvkom
        });
    }

    document.querySelectorAll('.modal-content').forEach(modalContentElement => {
        modalContentElement.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
    });

    document.querySelectorAll('.btn-close').forEach(btnCloseElement => {
        btnCloseElement.classList.toggle('btn-close-white', dark); // Pridá triedu 'btn-close-white', ak je tmavý režim aktívny
        btnCloseElement.classList.remove('dark'); // Odstráni triedu 'dark', ak je tmavý režim aktívny
    });

    document.querySelectorAll('.modal').forEach(modalElement => {
        modalElement.classList.toggle('dark', dark); // Pridá triedu 'dark', ak je tmavý režim aktívny
        
    });

    document.body.classList.remove('loading'); // Odstráni loading triedu
    document.body.classList.add('loaded'); // Pridá loaded triedu

    document.getElementById('resultInfoUL').innerHTML = data[0].info ? data[0].info.value : "info";
        
    document.getElementById('logoUrl').setAttribute('href', logoUrl);
    document.getElementById('logo').setAttribute('src', logo);
    document.getElementById('logoUrl2').setAttribute('href', logoUrl);
    document.getElementById('logo2').setAttribute('src', logo); 
    document.getElementById('logoUrl3').setAttribute('href', logoUrl);
    document.getElementById('logo3').setAttribute('src', logo); 

    let linkText = data[0].linkText ? data[0].linkText.value : "customLink";
    let linkUrl = data[0].linkUrl ? data[0].linkUrl.value : "#";

    document.querySelectorAll(".customLink").forEach(link => {
        link.textContent = linkText;
        link.href = linkUrl;
    });

    if (!dimOpen) {
       
        document.getElementById("width1").style.display = "flex";
        document.getElementById("height1").style.display = "flex";
      
    } else {
        document.getElementById("width1").style.display = "none";
        document.getElementById("height1").style.display = "none";
    }

    if (!dimValue) {
        document.getElementById("dimensions").style.opacity = "1";
    } else {
        document.getElementById("dimensions").style.opacity = "0";
    }

    if (!hideURL) {
        document.getElementById("hideURL").style.display = "none";
    } else {
        document.getElementById("hideURL").style.display = "block";
    }
    if (!hideSheet) {
        document.getElementById("hideSheet").style.display = "none";
    } else {
        document.getElementById("hideSheet").style.display = "block";
    }
    if (!hideOrder) {
        document.getElementById("order").style.display = "none";
    } else {
        document.getElementById("order").style.display = "block";   
    }
    if (!hideCalculator) {
        document.getElementById("calculatorIDhide").style.display = "none";
    } else {
        document.getElementById("calculatorIDhide").style.display = "flex";   
    }    
    const elements = document.getElementsByClassName("DPHcka");
for (let i = 0; i < elements.length; i++) {
    if (!hideDPH) {
        elements[i].style.display = "none";
    } else {
        elements[i].style.display = "flex";  // Zobraziť ako flex alebo iný štýl
    }
}
  

}, 1000); // Oneskanie 3000 milisekúnd (3 sekundy)


      
        document.title = hlavickaValue;
       // console.log("Hodnota dim: ", dimValue);
    },
    onError: function(error) {
        console.error("Error loading data from websheet:", error);
        alert("UPS..asi nemáš platnú adresu URL");
    }
});

}
